import { Injectable, signal } from '@angular/core';
import { OrderCartModel } from '@models/order/order-cart.model';

const STORAGE_KEY = 'current_order';

@Injectable({ providedIn: 'root' })
export class OrderService {
  private readonly _order = signal<OrderCartModel | null>(this.#restore());
  readonly currentOrder = this._order.asReadonly();

  save(order: OrderCartModel): void {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order));
    this._order.set(order);
  }

  removeItem(courseId: number): void {
    const current = this._order();
    if (!current) return;
    const items = current.items.filter((item) => item.course.id !== courseId);
    const supplementTotal = current.isMealPlanMode
      ? items
          .filter((item) => item.part.service_is_not_in_admission)
          .reduce((sum, item) => sum + (item.course.price ?? 0) * item.quantity, 0)
      : items.reduce((sum, item) => sum + (item.course.price ?? 0) * item.quantity, 0);
    const updated: OrderCartModel = {
      ...current,
      items,
      supplementTotal,
      totalPrice: current.formulaPrice + supplementTotal,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    this._order.set(updated);
  }

  clear(): void {
    sessionStorage.removeItem(STORAGE_KEY);
    this._order.set(null);
  }

  #restore(): OrderCartModel | null {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as OrderCartModel;
    } catch {
      return null;
    }
  }
}
